export const subtasksFilterConditions = [];
//# sourceMappingURL=filters.js.map